import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import ParticipantsBoardImpl from './participants-board.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Board that shows two or three participants on scoreboard.
 *
 * @class ParticipantsBoard
 * @memberof Mojito.Presentation.Components.Scoreboard
 */

/**
 * ParticipantsBoard prop types.
 *
 * @property {object} [event] - The event to display.
 * @memberof Mojito.Presentation.Components.Scoreboard.ParticipantsBoard
 */

const propTypes = {
    event: PropTypes.object,
};

export default UIView('ParticipantsBoard', ParticipantsBoardImpl, propTypes);
